import { err, ok } from 'neverthrow'
import { evaluatorErrorWithNode } from '../../scriptevaluator/EvaluatorError'
import { functionNodeTypes, HelperFunction } from '../FunctionTypes'
import { isSuperconceptStatus } from '../../../concept/ConceptTypeGuards'

export const TitlesFunction: HelperFunction = {
	tokenName: 'TITLES',
	nodeType: functionNodeTypes.Titles,
	evaluate(node, evaluateExpr, context) {
		if (node.arguments.length !== 1) {
			return err(evaluatorErrorWithNode('TITLES function expects exactly one argument', node))
		}
		const result = evaluateExpr(node.arguments[0])
		if (result.isErr()) return err(result.error)
		if (typeof result.value !== 'string') {
			return err(evaluatorErrorWithNode('TITLES function argument must evaluate to a string', node))
		}
		const cid = result.value
		const status = context.getStatus(cid)
		const titles: string[] = []
		if(isSuperconceptStatus(status)) {
			for (let subconceptCid in status.subconcepts) {
				if (context.substatusValue(cid, subconceptCid) === true) {
					let subconcept = context.getConcept(subconceptCid)
					if(!subconcept) {
						return err(evaluatorErrorWithNode(`TITLES function expected concept for '${subconceptCid}' but null`, node))
					}
					if (subconcept.title) {
						titles.push(subconcept.title)
					}
				}
			}
		}
		return ok(titles.join(', '))
	}
}
